import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getProducts = createAsyncThunk('/getProducts', async () => {
  const response = await axios.get('/GetNewlyDefinedProducts');
  return response.data;
});

export const getDefinedProduct = createAsyncThunk('/getDefinedProduct', async (sku) => {
  const response = await axios.get(`/GetDefinedProduct/${sku}`);
  return response.data;
});

export const updateNewlyDefinedProduct = createAsyncThunk(
  '/updateNewlyDefinedProduct',
  async req => {
    const response = await axios.post('/UpdateNewlyDefinedProduct', req);  
    return response.data;
    
  }
);

export const getCampaignTypes = createAsyncThunk(
  '/getCampaignTypes',
  async () => {
    const response = await axios.get('/GetCampaignTypes');
    return response.data;
  }
);

export const getTechnologyTypes = createAsyncThunk(
  '/getTechnologyTypes',
  async () => {
    const response = await axios.get('/GetTechnologyTypes');
    return response.data;
  }
);

export const getBrands = createAsyncThunk(
  '/getBrands',
  async () => {
    const response = await axios.get(`/GetBrandsByName`);
    return response.data;
  }
);


export const getFuelTypes = createAsyncThunk('/getFuelTypes', async () => {
  const response = await axios.get('/GetFuelTypes');
  return response.data;
});

export const getTaskTypes = createAsyncThunk('/getTaskTypes', async () => {
  const response = await axios.get('/GetTaskTypes');
  return response.data;
});

export const getDynamicGroups = createAsyncThunk('/getDynamicGroups', async () => {
  const response = await axios.get('/GetDynamicGroup');
  return response.data === '' ? [] : response.data;
});

const productLaunchSlice = createSlice({
  name: 'productLaunch',
  initialState: {
    loading: false,
    error: '',
    CampaignType: [],
    TechnologyType: [],
    FuelType: [],
    TaskType: [],
    products: [],
    product: {},
    Brands: [],
    DynamicGroup: []
  },
  reducers: {
    resetProducts(state) {
      state.products = [];
      state.product = {};
    }
  },
  extraReducers: {
    [getProducts.pending]: state => {
      state.loading = true;
    },
    [getProducts.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProducts.fulfilled]: (state, action) => {
      state.products = action.payload;
      state.loading = false;
    },
    [updateNewlyDefinedProduct.pending]: state => {
      state.loading = true;
    },
    [updateNewlyDefinedProduct.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [updateNewlyDefinedProduct.fulfilled]: (state, action) => {
      state.products = action.payload;
      state.loading = false;
    },
    [getCampaignTypes.pending]: state => {
      state.loading = true;
    },
    [getCampaignTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCampaignTypes.fulfilled]: (state, action) => {
      state.CampaignType = action.payload;
      state.loading = false;
    },
    [getFuelTypes.pending]: state => {
      state.loading = true;
    },
    [getFuelTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getFuelTypes.fulfilled]: (state, action) => {
      state.FuelType = action.payload;
      state.loading = false;
    },
    [getTechnologyTypes.pending]: state => {
      state.loading = true;
    },
    [getTechnologyTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnologyTypes.fulfilled]: (state, action) => {
      state.TechnologyType = action.payload;
      state.loading = false;
    },
    [getTaskTypes.pending]: state => {
      state.loading = true;
    },
    [getTaskTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTaskTypes.fulfilled]: (state, action) => {
      state.TaskType = action.payload;
      state.loading = false;
    },
    [getBrands.pending]: state => {
      state.loading = true;
    },
    [getBrands.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getBrands.fulfilled]: (state, action) => {
      state.Brands = action.payload;
      state.loading = false;
    },
    [getDefinedProduct.pending]: state => {
      state.loading = true;
    },
    [getDefinedProduct.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefinedProduct.fulfilled]: (state, action) => {
      state.product = action.payload;
      state.loading = false;
    },
    [getDynamicGroups.pending]: state => {
      state.loading = true;
    },
    [getDynamicGroups.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDynamicGroups.fulfilled]: (state, action) => {
      state.DynamicGroup = action.payload;
      state.loading = false;
    },
  }
});

export const productLaunchActions = productLaunchSlice.actions;

export default productLaunchSlice;
